import { PinkGradientLink } from '@/shared/components/Link/PinkGradientLink';
import { StyledCol, StyledRowOffset, StyledTitle } from '@/shared/styles';
import { AllIssues } from './AllIssues/AllIssues';
import { FilteredIssues } from './FilteredIssues/FilteredIssues';
import { isDesktop } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { downloadPdf } from './AccessibilityIssues.utils';
import { Recommendations } from './Recommendations/Recommendations';
import { StyledIssuesContainer } from './AccessibilityIssues.styles';

export const AccessibilityIssues: React.FC = () => {
  const accessibilityCheckerStore = useAccessibilityCheckerStore();
  const { t } = useTranslation();

  return (
    <StyledCol $gap={20}>
      <StyledRowOffset>
        <StyledTitle level={2} $size={28}>
          {t('free_tools.accessibility_checker.a11y_issues')}:
        </StyledTitle>
        {isDesktop && (
          <PinkGradientLink
            isButton={true}
            text={t('free_tools.download_pdf')}
            onClick={() => downloadPdf(accessibilityCheckerStore)}
          />
        )}
      </StyledRowOffset>
      <StyledIssuesContainer>
        <AllIssues />
        <FilteredIssues />
      </StyledIssuesContainer>
      <Recommendations />
    </StyledCol>
  );
};
